import axios from 'axios';
import {getEnv, notEmpty} from 'main/utility/CommonUtil';
import {debugLogApi} from 'main/utility/DebugUtil';

const jwtAxios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

jwtAxios.interceptors.request.use(
  (config) => {
    config.baseURL = getEnv('REACT_APP_CORE_URL', 'http://localhost/core/');
    debugLogApi('REQUEST', config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

jwtAxios.interceptors.response.use(
  (response) => {
    debugLogApi('RESPONSE', response.config, response);
    return response;
  },
  (error) => {
    debugLogApi('ERROR', error.config || {}, error);
    return Promise.reject(error);
  },
);

export const setAuthInfo = (authInfo) => {
  if (isAuthorized(authInfo) && notEmpty(authInfo?.token)) {
    sessionStorage.setItem('currentUser', JSON.stringify(authInfo));
    const cleanToken = authInfo.token.replace(/"/g, '');
    jwtAxios.defaults.headers.common['uiWiseRegToken'] = cleanToken;
  } else {
    sessionStorage.clear();
    jwtAxios.defaults.headers.common['uiWiseRegToken'] = null;
    delete jwtAxios.defaults.headers.common['uiWiseRegToken'];
  }
};

export const getCurrentUser = () => {
  const currentUser = sessionStorage.getItem('currentUser');
  return currentUser ? JSON.parse(currentUser) : null;
};

export const isAuthorized = (authInfo) => {
  return Boolean(authInfo?.authorized);
};

export default jwtAxios;
